import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private currentPageSubject: BehaviorSubject<any>;
  public currentPage: Observable<any>;
  private previousPageSubject: BehaviorSubject<any>;
  public previousPage: Observable<any>;

  constructor() {
    this.currentPageSubject = new BehaviorSubject<any>(JSON.parse(sessionStorage.getItem('currentPage')));
    this.previousPageSubject = new BehaviorSubject<any>(JSON.parse(sessionStorage.getItem('previousPage')));
    this.currentPage = this.currentPageSubject.asObservable();
    this.previousPage = this.previousPageSubject.asObservable();
  }

  resetNavigation() {
    sessionStorage.removeItem('currentPage');
    sessionStorage.removeItem('previousPage');
    this.currentPageSubject.next(null);
    this.previousPageSubject.next(null);
  }

  savePreviousPage(page) {
    sessionStorage.setItem('previousPage', JSON.stringify(page));
    this.previousPageSubject.next(page);
  }

  goToPreviousPage() {
    this.previousPage.subscribe(page => {
      sessionStorage.removeItem('previousPage');
      sessionStorage.setItem('currentPage', JSON.stringify(page));
      this.currentPageSubject.next(page);
    });
  }

  goToPage(page) {
    sessionStorage.setItem('currentPage', JSON.stringify(page));
    this.currentPageSubject.next(page);
  }
}
